// @flow
import environment from '../../environment';
import { getCreator } from '../../http';
import { of } from 'rxjs';

export const endpoints = Object.freeze({
  GET_PRODUCT_LIST: `${environment.apiUrl}/products/list/:name`,
});

export const getProductListApi = getCreator(fetch, endpoints.GET_PRODUCT_LIST);
/*export const getProductListApi = (a?: any, b?: any) => of(
  {
    'type': 'product-list',
    'id': 'PL16686519',
    'slug': 'test',
    'image': 'https://cloudfront.timesnownews.com/media/5_edited.png',
    'color': '1e2023',
    'products': [
      {
        'type': 'product-list-item',
        'id': 'PLI16686519',
        'url': 'www.google.com',
        'name': 'test 1',
        'detail': 'test',
        'image': 'http://placekitten.com/g/200/300',
        'price': '10.25',
        'weight': '0.20',
        'amount': 1,
        'categoryId': 1,
        'originalPackaging': true
      },
      /!*{
        'type': 'product-list-item',
        'id': 'PLI16686519',
        'url': 'www.google.com',
        'name': 'test 1',
        'detail': 'test',
        'image': 'http://placekitten.com/g/200/300',
        'price': '10.25',
        'weight': '0.20',
        'amount': 1,
        'categoryId': 1,
        'originalPackaging': true
      },*!/
    ],
    'relatedProducts': [
      {
        'type': 'product-list-item',
        'id': 'PLI09043495',
        'url': 'www.google.com',
        'name': 'test 3',
        'detail': 'test',
        'image': 'http://placekitten.com/g/200/300',
        'price': '10.25',
        'weight': '0.20',
        'amount': 1,
        'categoryId': 1,
        'originalPackaging': true
      },
      {
        'type': 'product-list-item',
        'id': 'PLI08210077',
        'url': 'www.google.com',
        'name': 'test 4',
        'detail': 'test',
        'image': 'http://placekitten.com/g/200/300',
        'price': '10.25',
        'weight': '0.20',
        'amount': 1,
        'categoryId': 1,
        'originalPackaging': true
      }
    ],
    'subtitle': {
      'EN': 'test sub',
      'ES': 'prueba sub'
    },
    'title': {
      'EN': 'test',
      'ES': 'prueba'
    }
  }
);*/



// WEBPACK FOOTER //
// ./src/modules/product-list/api.js